import type { Selector, State } from 'model/State';

export const selectSwitchedUser: Selector<string> = (state: State) => state.mac.configUser.email;
